// config.js
// ✅ This file reads from environment variables defined in `.env`
// ✅ Only variables prefixed with REACT_APP_ are exposed in React apps

const PORT = process.env.REACT_APP_PORT;

// Log values for debugging
// console.log("APP ENV:", process.env.REACT_APP_NODE_ENV);
// console.log("APP PORT:", PORT);

let APP;

// 🌐 Environment-specific configuration
if (process.env.REACT_APP_NODE_ENV === "development") {
  APP = {
    // 👇 Used when running locally in dev mode
    imageURL: `http://localhost:${PORT}/imagePath`,
    baseURL: `http://localhost:${PORT}`,
  };
} else if (process.env.REACT_APP_NODE_ENV === "stagging") {
  APP = {
    // 👇 Staging server endpoints
    baseURL: "https://dev.thebestdeals.app",
    imageURL: "https://dev.thebestdeals.app/tbd_images",
  };
} else {
  APP = {
    // 👇 Production server endpoints
    baseURL: "https://team.thebestdeals.app",
    imageURL: "https://team.thebestdeals.app/tbd_images",
  };
}

export default APP;
